// extracted by mini-css-extract-plugin
export default {"eventName":"_1xgm","eventDescription":"bnZK","eventText":"_2tf8","trigger":"_2ZQ9"};